module.exports = __webpack_public_path__ + "static/media/March2022Newsletter.3977a937.pdf";